var _symbol, _symbol2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSprite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "icon-bar_chart-24px",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c7ccdc",
    style: {
      fill: "var(--color1, #c7ccdc)"
    },
    d: "M6.667 12.267h4v13.067h-4v-13.067zM14.133 6.667h3.733v18.667h-3.733v-18.667zM21.6 17.333h3.733v8h-3.733v-8z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-calculator",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c7ccdc",
    style: {
      fill: "var(--color1, #c7ccdc)"
    },
    d: "M27.25 0h-22.5c-1.551 0-2.813 1.262-2.813 2.813v26.375c0 1.551 1.262 2.812 2.813 2.812h22.5c1.551 0 2.813-1.262 2.813-2.812v-26.375c0-1.551-1.262-2.813-2.813-2.813zM28.188 29.188c0 0.517-0.421 0.937-0.938 0.937h-22.5c-0.517 0-0.938-0.42-0.938-0.937v-26.375c0-0.517 0.421-0.938 0.938-0.938h22.5c0.517 0 0.938 0.421 0.938 0.938v26.375z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7ccdc",
    style: {
      fill: "var(--color1, #c7ccdc)"
    },
    d: "M25.375 3.75h-18.75c-0.518 0-0.938 0.42-0.938 0.938v7.625c0 0.518 0.42 0.938 0.938 0.938h18.75c0.518 0 0.937-0.42 0.937-0.938v-7.625c0-0.518-0.42-0.938-0.937-0.938zM24.437 11.375h-16.875v-5.75h16.875v5.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7ccdc",
    style: {
      fill: "var(--color1, #c7ccdc)"
    },
    d: "M10.375 15.125h-3.75c-0.518 0-0.938 0.42-0.938 0.938v3.75c0 0.518 0.42 0.938 0.938 0.938h3.75c0.518 0 0.938-0.42 0.938-0.938v-3.75c0-0.518-0.42-0.938-0.938-0.938zM9.438 18.875h-1.875v-1.875h1.875v1.875z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7ccdc",
    style: {
      fill: "var(--color1, #c7ccdc)"
    },
    d: "M10.375 22.625h-3.75c-0.518 0-0.938 0.42-0.938 0.938v3.75c0 0.518 0.42 0.937 0.938 0.937h3.75c0.518 0 0.938-0.42 0.938-0.937v-3.75c0-0.518-0.42-0.938-0.938-0.938zM9.438 26.375h-1.875v-1.875h1.875v1.875z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7ccdc",
    style: {
      fill: "var(--color1, #c7ccdc)"
    },
    d: "M17.875 15.125h-3.75c-0.518 0-0.938 0.42-0.938 0.938v3.75c0 0.518 0.42 0.938 0.938 0.938h3.75c0.518 0 0.937-0.42 0.937-0.938v-3.75c0-0.518-0.42-0.938-0.937-0.938zM16.937 18.875h-1.875v-1.875h1.875v1.875z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7ccdc",
    style: {
      fill: "var(--color1, #c7ccdc)"
    },
    d: "M17.875 22.625h-3.75c-0.518 0-0.938 0.42-0.938 0.938v3.75c0 0.518 0.42 0.937 0.938 0.937h3.75c0.518 0 0.937-0.42 0.937-0.937v-3.75c0-0.518-0.42-0.938-0.937-0.938zM16.937 26.375h-1.875v-1.875h1.875v1.875z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7ccdc",
    style: {
      fill: "var(--color1, #c7ccdc)"
    },
    d: "M25.375 15.125h-3.75c-0.518 0-0.937 0.42-0.937 0.938v11.25c0 0.518 0.42 0.937 0.937 0.937h3.75c0.518 0 0.937-0.42 0.937-0.937v-11.25c0-0.518-0.42-0.938-0.937-0.938zM24.437 26.375h-1.875v-9.375h1.875v9.375z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-drop-arrow",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#80848f",
    strokeWidth: 5.3333,
    strokeMiterlimit: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    style: {
      stroke: "var(--color2, #80848f)"
    },
    d: "M2.667 9.333l13.333 10.667 13.333-10.667"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "vertical-line",
    viewBox: "0 0 2 36"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e0e5eb",
    strokeWidth: 0.8889,
    strokeMiterlimit: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    style: {
      stroke: "var(--color1, #e0e5eb)"
    },
    d: "M0.889 0v32"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-google-symbol",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2196f3",
    style: {
      fill: "var(--color3, #2196f3)"
    },
    d: "M30.567 13.038c0.136 0 0.246 0.115 0.246 0.258v2.704c0 1.012-0.090 2.002-0.262 2.962-1.331 7.457-7.599 13.092-15.111 13.038-8.43-0.061-15.176-7.2-15.158-16.036 0.019-8.82 6.846-15.964 15.265-15.964 4.125 0 7.867 1.715 10.615 4.501 0.099 0.101 0.102 0.266 0.004 0.369l-3.65 3.826c-0.094 0.098-0.246 0.101-0.342 0.005-1.725-1.721-4.058-2.777-6.627-2.777-5.305 0-9.578 4.446-9.614 10.007-0.036 5.597 4.282 10.146 9.614 10.146 4.326 0 7.985-2.995 9.191-7.115h-8.945c-0.136 0-0.246-0.115-0.246-0.258v-5.408c0-0.142 0.11-0.258 0.246-0.258l14.774 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1e88e5",
    style: {
      fill: "var(--color4, #1e88e5)"
    },
    d: "M30.567 13.038h-1.843c0.136 0 0.246 0.115 0.246 0.258v2.704c0 1.012-0.090 2.002-0.262 2.962-1.27 7.114-7.033 12.57-14.083 13.009 0.27 0.017 0.541 0.026 0.815 0.028 7.513 0.054 13.78-5.581 15.111-13.038 0.172-0.96 0.262-1.95 0.262-2.962v-2.704c0-0.142-0.11-0.258-0.246-0.258z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f44336",
    style: {
      fill: "var(--color5, #f44336)"
    },
    d: "M6.815 11.78l-4.636-3.511c2.601-4.931 7.613-8.269 13.368-8.269 4.125 0 7.867 1.715 10.615 4.501 0.099 0.101 0.102 0.266 0.004 0.369l-3.65 3.826c-0.094 0.098-0.245 0.101-0.341 0.005-1.725-1.721-4.058-2.777-6.628-2.777-3.872 0-7.209 2.399-8.732 5.857z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e53935",
    style: {
      fill: "var(--color6, #e53935)"
    },
    d: "M5.477 10.767l1.338 1.014c1.39-3.156 4.292-5.429 7.732-5.802 0.026-0.003 0.051-0.006 0.077-0.009-0.303-0.030-0.61-0.046-0.92-0.046-3.498 0-6.546 1.933-8.228 4.843z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e53935",
    style: {
      fill: "var(--color6, #e53935)"
    },
    d: "M24.319 4.501c0.099 0.101 0.102 0.266 0.004 0.369l-2.963 3.105c0.284 0.226 0.556 0.468 0.813 0.726 0.096 0.096 0.248 0.094 0.342-0.005l3.65-3.826c0.098-0.102 0.095-0.268-0.004-0.369-2.748-2.786-6.49-4.501-10.615-4.501-0.31 0-0.617 0.011-0.922 0.030 3.759 0.235 7.152 1.894 9.694 4.471z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    style: {
      fill: "var(--color7, #4caf50)"
    },
    d: "M26.745 26.873c-2.788 3.153-6.773 5.126-11.198 5.126-5.976 0-11.151-3.6-13.656-8.844l4.733-3.4c1.42 3.704 4.881 6.32 8.923 6.32 2.537 0 4.844-1.030 6.562-2.713l4.636 3.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42a652",
    style: {
      fill: "var(--color8, #42a652)"
    },
    d: "M6.624 19.756l-1.396 1.003c1.621 3.165 4.809 5.318 8.476 5.318 0.31 0 0.617-0.016 0.919-0.046-3.64-0.364-6.689-2.855-8-6.274z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42a652",
    style: {
      fill: "var(--color8, #42a652)"
    },
    d: "M15.548 32c4.425 0 8.41-1.974 11.198-5.126l-1.135-0.86c-2.618 3.414-6.544 5.679-10.982 5.957 0.304 0.019 0.611 0.029 0.919 0.029z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    style: {
      fill: "var(--color9, #ffc107)"
    },
    d: "M5.934 16c0 1.328 0.245 2.595 0.69 3.756l-4.733 3.4c-1.030-2.153-1.609-4.584-1.609-7.156 0-2.804 0.688-5.439 1.897-7.731l4.636 3.511c-0.566 1.283-0.881 2.713-0.881 4.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb300",
    style: {
      fill: "var(--color10, #ffb300)"
    },
    d: "M5.228 20.759l1.396-1.003c-0.445-1.161-0.69-2.429-0.69-3.756 0-1.507 0.316-2.937 0.881-4.22l-1.338-1.014c-0.869 1.504-1.373 3.269-1.386 5.164-0.011 1.747 0.402 3.392 1.137 4.829z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-keyboard_backspace-24px",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f6f7fb",
    style: {
      fill: "var(--color11, #f6f7fb)"
    },
    d: "M28 14.667h-18.893l4.773-4.787-1.88-1.88-8 8 8 8 1.88-1.88-4.773-4.787h18.893v-2.667z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "horizontal-line",
    viewBox: "0 0 4480 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#474759",
    strokeWidth: 16,
    strokeMiterlimit: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    style: {
      stroke: "var(--color1, #474759)"
    },
    d: "M0 16l4480-0"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-logout",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f6f7fb",
    style: {
      fill: "var(--color11, #f6f7fb)"
    },
    d: "M20 28h-16v-24h16v2h4v-6h-24v32h24v-6h-4v2h-0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6f7fb",
    style: {
      fill: "var(--color11, #f6f7fb)"
    },
    d: "M24.586 8.586l-2.828 2.828 2.586 2.586h-10.344v4h10.344l-2.586 2.586 2.828 2.828 7.414-7.414-7.414-7.414z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-plus",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f6f7fb",
    stroke: "#f6f7fb",
    strokeWidth: 3.4286,
    strokeMiterlimit: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      stroke: "var(--color11, #f6f7fb)"
    },
    d: "M16 2.286v27.429"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6f7fb",
    stroke: "#f6f7fb",
    strokeWidth: 3.4286,
    strokeMiterlimit: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      stroke: "var(--color11, #f6f7fb)"
    },
    d: "M2.286 16h27.429"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-side-arrow",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f6f7fb",
    strokeWidth: 5.3333,
    strokeMiterlimit: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      stroke: "var(--color11, #f6f7fb)"
    },
    d: "M22.667 29.333l-13.333-13.333 13.333-13.333"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-toright",
    viewBox: "0 0 19 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#60c470",
    strokeWidth: 5.3333,
    strokeMiterlimit: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    style: {
      stroke: "var(--color1, #60c470)"
    },
    d: "M2.667 2.667l10.667 13.333-10.667 13.333"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-toleft",
    viewBox: "0 0 19 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#60c470",
    strokeWidth: 5.3333,
    strokeMiterlimit: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    style: {
      stroke: "var(--color1, #60c470)"
    },
    d: "M16 2.667l-10.667 13.333 10.667 13.333"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-trash-bin",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c7ccdc",
    opacity: 0.5,
    style: {
      fill: "var(--color1, #c7ccdc)"
    },
    d: "M28.992 7.153l-0.706-2.118c-0.269-0.807-1.021-1.349-1.871-1.349h-5.938v-1.933c0-0.966-0.786-1.753-1.752-1.753h-5.438c-0.966 0-1.752 0.786-1.752 1.753v1.933h-5.938c-0.85 0-1.603 0.542-1.872 1.349l-0.707 2.118c-0.161 0.482-0.079 1.016 0.218 1.428s0.778 0.659 1.286 0.659h0.739l1.625 20.1c0.121 1.491 1.386 2.66 2.882 2.66h12.804c1.495 0 2.761-1.169 2.882-2.66l1.626-20.1h0.409c0.508 0 0.989-0.246 1.286-0.658s0.379-0.947 0.218-1.429zM13.41 1.875h5.191v1.811h-5.191v-1.811zM23.585 29.189c-0.043 0.525-0.487 0.936-1.013 0.936h-12.804c-0.525 0-0.97-0.411-1.013-0.936l-1.614-19.949h18.056l-1.613 19.949zM4.925 7.365l0.579-1.737c0.013-0.040 0.051-0.067 0.093-0.067h20.818c0.042 0 0.079 0.027 0.093 0.067l0.579 1.737h-22.162z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7ccdc",
    opacity: 0.5,
    style: {
      fill: "var(--color1, #c7ccdc)"
    },
    d: "M20.595 29.122c0.017 0.001 0.033 0.001 0.050 0.001 0.495 0 0.909-0.388 0.935-0.889l0.88-16.9c0.027-0.517-0.371-0.958-0.887-0.985-0.518-0.028-0.958 0.37-0.985 0.887l-0.88 16.9c-0.027 0.517 0.37 0.958 0.887 0.985z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7ccdc",
    opacity: 0.5,
    style: {
      fill: "var(--color1, #c7ccdc)"
    },
    d: "M10.473 28.237c0.027 0.5 0.441 0.886 0.935 0.886 0.017 0 0.035-0 0.052-0.001 0.517-0.028 0.913-0.47 0.885-0.987l-0.922-16.9c-0.028-0.517-0.47-0.913-0.987-0.885s-0.913 0.47-0.885 0.987l0.922 16.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7ccdc",
    opacity: 0.5,
    style: {
      fill: "var(--color1, #c7ccdc)"
    },
    d: "M16.016 29.124c0.518 0 0.938-0.42 0.938-0.938v-16.9c0-0.518-0.42-0.938-0.938-0.938s-0.938 0.42-0.938 0.938v16.9c0 0.518 0.42 0.938 0.938 0.938z"
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-cross",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.708 25.708c-0-0-0-0-0-0l-9.708-9.708 9.708-9.708c0-0 0-0 0-0 0.105-0.105 0.18-0.227 0.229-0.357 0.133-0.356 0.057-0.771-0.229-1.057l-4.586-4.586c-0.286-0.286-0.702-0.361-1.057-0.229-0.13 0.048-0.252 0.124-0.357 0.228 0 0-0 0-0 0l-9.708 9.708-9.708-9.708c-0-0-0-0-0-0-0.105-0.104-0.227-0.18-0.357-0.228-0.356-0.133-0.771-0.057-1.057 0.229l-4.586 4.586c-0.286 0.286-0.361 0.702-0.229 1.057 0.049 0.13 0.124 0.252 0.229 0.357 0 0 0 0 0 0l9.708 9.708-9.708 9.708c-0 0-0 0-0 0-0.104 0.105-0.18 0.227-0.229 0.357-0.133 0.355-0.057 0.771 0.229 1.057l4.586 4.586c0.286 0.286 0.702 0.361 1.057 0.229 0.13-0.049 0.252-0.124 0.357-0.229 0-0 0-0 0-0l9.708-9.708 9.708 9.708c0 0 0 0 0 0 0.105 0.105 0.227 0.18 0.357 0.229 0.356 0.133 0.771 0.057 1.057-0.229l4.586-4.586c0.286-0.286 0.362-0.702 0.229-1.057-0.049-0.13-0.124-0.252-0.229-0.357z"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-cross-modal",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C7CCDC",
    d: "M31.708 25.708c-0-0-0-0-0-0l-9.708-9.708 9.708-9.708c0-0 0-0 0-0 0.105-0.105 0.18-0.227 0.229-0.357 0.133-0.356 0.057-0.771-0.229-1.057l-4.586-4.586c-0.286-0.286-0.702-0.361-1.057-0.229-0.13 0.048-0.252 0.124-0.357 0.228 0 0-0 0-0 0l-9.708 9.708-9.708-9.708c-0-0-0-0-0-0-0.105-0.104-0.227-0.18-0.357-0.228-0.356-0.133-0.771-0.057-1.057 0.229l-4.586 4.586c-0.286 0.286-0.361 0.702-0.229 1.057 0.049 0.13 0.124 0.252 0.229 0.357 0 0 0 0 0 0l9.708 9.708-9.708 9.708c-0 0-0 0-0 0-0.104 0.105-0.18 0.227-0.229 0.357-0.133 0.355-0.057 0.771 0.229 1.057l4.586 4.586c0.286 0.286 0.702 0.361 1.057 0.229 0.13-0.049 0.252-0.124 0.357-0.229 0-0 0-0 0-0l9.708-9.708 9.708 9.708c0 0 0 0 0 0 0.105 0.105 0.227 0.18 0.357 0.229 0.356 0.133 0.771 0.057 1.057-0.229l4.586-4.586c0.286-0.286 0.362-0.702 0.229-1.057-0.049-0.13-0.124-0.252-0.229-0.357z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-calendar",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C7CCDC",
    style: {
      fill: "var(--color1, #C7CCDC)"
    },
    d: "M27.961 3.307h-2.099v-0.514c0-0.518-0.42-0.938-0.937-0.938s-0.937 0.42-0.937 0.938v0.514h-2.587v-0.514c0-0.518-0.42-0.938-0.938-0.938s-0.937 0.42-0.937 0.938v0.514h-2.587v-0.514c0-0.518-0.42-0.938-0.937-0.938s-0.938 0.42-0.938 0.938v0.514h-2.587v-0.514c0-0.518-0.42-0.938-0.938-0.938s-0.938 0.42-0.938 0.938v0.514h-2.587v-0.514c0-0.518-0.42-0.938-0.938-0.938s-0.938 0.42-0.938 0.938v0.514h-2.099c-2.227 0-4.039 1.812-4.039 4.039v18.758c0 2.227 1.812 4.039 4.039 4.039h23.921c2.227 0 4.039-1.812 4.039-4.039v-18.758c0-2.227-1.812-4.039-4.039-4.039zM30.125 26.105c0 1.193-0.971 2.164-2.164 2.164h-23.921c-1.193 0-2.164-0.971-2.164-2.164v-15.333h28.25v15.333zM30.125 8.897h-28.25v-1.55c0-1.193 0.971-2.164 2.164-2.164h2.099v0.362c0 0.518 0.42 0.938 0.938 0.938s0.938-0.42 0.938-0.938v-0.362h2.587v0.362c0 0.518 0.42 0.938 0.938 0.938s0.938-0.42 0.938-0.938v-0.362h2.587v0.362c0 0.518 0.42 0.938 0.938 0.938s0.937-0.42 0.937-0.938v-0.362h2.587v0.362c0 0.518 0.42 0.938 0.937 0.938s0.938-0.42 0.938-0.938v-0.362h2.587v0.362c0 0.518 0.42 0.938 0.937 0.938s0.937-0.42 0.937-0.938v-0.362h2.099c1.193 0 2.164 0.971 2.164 2.164v1.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C7CCDC",
    style: {
      fill: "var(--color1, #C7CCDC)"
    },
    d: "M10.451 12.771h-3.699c-0.518 0-0.938 0.42-0.938 0.938v3.827c0 0.518 0.42 0.937 0.938 0.937h3.699c0.518 0 0.938-0.42 0.938-0.937v-3.827c0-0.518-0.42-0.938-0.938-0.938zM9.513 16.598h-1.824v-1.952h1.824v1.952z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C7CCDC",
    style: {
      fill: "var(--color1, #C7CCDC)"
    },
    d: "M17.85 12.771h-3.699c-0.518 0-0.938 0.42-0.938 0.938v3.827c0 0.518 0.42 0.937 0.938 0.937h3.699c0.518 0 0.937-0.42 0.937-0.937v-3.827c0-0.518-0.42-0.938-0.937-0.938zM16.912 16.598h-1.824v-1.952h1.824v1.952z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C7CCDC",
    style: {
      fill: "var(--color1, #C7CCDC)"
    },
    d: "M25.248 12.771h-3.699c-0.518 0-0.937 0.42-0.937 0.938v3.827c0 0.518 0.42 0.937 0.937 0.937h3.699c0.518 0 0.937-0.42 0.937-0.937v-3.827c0-0.518-0.42-0.938-0.937-0.938zM24.311 16.598h-1.824v-1.952h1.824v1.952z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C7CCDC",
    style: {
      fill: "var(--color1, #C7CCDC)"
    },
    d: "M10.451 20.041h-3.699c-0.518 0-0.938 0.42-0.938 0.938v3.827c0 0.518 0.42 0.938 0.938 0.938h3.699c0.518 0 0.938-0.42 0.938-0.938v-3.827c0-0.518-0.42-0.938-0.938-0.938zM9.513 23.869h-1.824v-1.952h1.824v1.952z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C7CCDC",
    style: {
      fill: "var(--color1, #C7CCDC)"
    },
    d: "M17.85 20.041h-3.699c-0.518 0-0.938 0.42-0.938 0.938v3.827c0 0.518 0.42 0.938 0.938 0.938h3.699c0.518 0 0.937-0.42 0.937-0.938v-3.827c0-0.518-0.42-0.938-0.937-0.938zM16.912 23.869h-1.824v-1.952h1.824v1.952z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C7CCDC",
    style: {
      fill: "var(--color1, #C7CCDC)"
    },
    d: "M25.248 20.041h-3.699c-0.518 0-0.937 0.42-0.937 0.938v3.827c0 0.518 0.42 0.938 0.937 0.938h3.699c0.518 0 0.937-0.42 0.937-0.938v-3.827c0-0.518-0.42-0.938-0.937-0.938zM24.311 23.869h-1.824v-1.952h1.824v1.952z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.dc1adc3332f34d07be0af435406910ca.svg";
export { ForwardRef as ReactComponent };